import type {
  IJobTasksApi,
  TCancelJobTaskParams,
  TCreateJobTaskParams,
  TDeleteJobTasksParams,
  TGetJobTaskByIdParams,
  TGetJobTasksParams,
  TJobTaskCreateRequestBody,
  TJobTaskScheduleRequestBody,
  TScheduleJobTaskParams,
  TUpdateJobTaskByIdParams
} from '@/types/api-types/job-tasks'
import type { TApiResponse } from '@/types/api-types/TApiResponse'
import { expandedJobTaskProperties, expandedProperties } from '@/utils/constants'
import BaseApiRequest from '../BaseApiRequest'
import JobTasksApiUrls from './endpoints'
import type { IJobTaskUpdate } from '@/interfaces/jobs/IJobTaskUpdate'

class JobTasksApiRequest extends BaseApiRequest implements IJobTasksApi {
  async getJobTasks(params: TGetJobTasksParams): TApiResponse {
    const { jobId, ...rest } = params
    return this.get(JobTasksApiUrls.JOB_TASKS(jobId), rest)
  }

  async getJobTask(params: TGetJobTaskByIdParams): TApiResponse {
    const { jobId, taskId, ...rest } = params
    return this.get(JobTasksApiUrls.JOB_TASK_BY_ID(jobId, taskId), rest)
  }

  async createJobTask(
    params: TCreateJobTaskParams,
    requestBody: TJobTaskCreateRequestBody
  ): TApiResponse {
    const { jobId, ...rest } = params
    return this.post(JobTasksApiUrls.JOB_TASKS(jobId), requestBody, {
      ...rest,
      ...expandedProperties
    })
  }

  async updateJobTask(params: TUpdateJobTaskByIdParams, requestBody: IJobTaskUpdate): TApiResponse {
    const { jobId, taskId, ...rest } = params
    return this.put(JobTasksApiUrls.JOB_TASK_BY_ID(jobId, taskId), requestBody, {
      ...rest,
      ...expandedJobTaskProperties
    })
  }

  async deleteJobTasks(params: TDeleteJobTasksParams): TApiResponse {
    const { jobId, ...rest } = params
    return this.delete(JobTasksApiUrls.JOB_TASKS(jobId), rest)
  }

  async cancelJobTask(params: TCancelJobTaskParams): TApiResponse {
    const { jobId, taskId, ...rest } = params
    return this.post(JobTasksApiUrls.JOB_TASK_CANCEL(jobId, taskId), {}, rest)
  }

  async scheduleJobTask(
    params: TScheduleJobTaskParams,
    requestBody: TJobTaskScheduleRequestBody
  ): TApiResponse {
    const { jobId, taskId, ...rest } = params
    return this.post(JobTasksApiUrls.JOB_TASK_SCHEDULE(jobId, taskId), requestBody, rest)
  }
}

export default JobTasksApiRequest
